import { useState } from "react";
import formatNumber from "../../services/formatNumber";
import AppCharts from "../AppCharts";
import AppTooltip from "../AppTooltip";
import { ChartMetrics } from "../../pages/home";
import "./AdsCards.css";

type AnalyticDataType = {
  fill_rate: number;
  total_received: number;
  total_requested: number;
};

type DateRangeMode = "Day" | "Week" | "Month" | "Custom";

interface Props {
  isAnalyticalView: boolean;
  analyticData?: AnalyticDataType | null;
  chartData?: ChartMetrics[] | null;
  dateRangeMode: DateRangeMode;
}

export default function AdsCards({
  isAnalyticalView,
  analyticData,
  chartData,
  dateRangeMode,
}: Props) {
  const [tooltip, setTooltip] = useState<{
    text: string;
    x: number;
    y: number;
  } | null>(null);

  const handleMouseEnter = (e: React.MouseEvent, text: string) => {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    setTooltip({
      text,
      x: rect.left + rect.width / 2,
      y: rect.top - 2,
    });
  };

  const handleMouseLeave = () => {
    setTooltip(null);
  };

  const getChartDataByMetric = (metric: keyof ChartMetrics) => {
    if (!chartData) return [];
    return chartData.map((item) => ({
      name: item.display_name,
      pv: item[metric],
    }));
  };

  return (
    <div className="ads-cards">
      <h2 className="ads-transaction-title">Ads Transactions</h2>
      <div className="ads-cards-listing">
        <article>
          <div className="ads-cards-title">
            <span>Ads Requested</span>
            <strong>
              <span
                onMouseEnter={(e) =>
                  handleMouseEnter(
                    e,
                    `${(analyticData?.total_requested ?? 0).toLocaleString()}`
                  )
                }
                onMouseLeave={handleMouseLeave}
              >
                {formatNumber(analyticData?.total_requested ?? 0)}
              </span>
            </strong>
          </div>
          {isAnalyticalView && (
            <AppCharts
              height={140}
              color="#ffffff"
              data={getChartDataByMetric("total_requested")}
              tickColor="#ffffff"
            />
          )}
        </article>
        <article>
          <div className="ads-cards-title">
            <span>Ads Received</span>
            <strong>
              <span
                onMouseEnter={(e) =>
                  handleMouseEnter(
                    e,
                    `${(analyticData?.total_received ?? 0).toLocaleString()}`
                  )
                }
                onMouseLeave={handleMouseLeave}
              >
                {formatNumber(analyticData?.total_received ?? 0)}
              </span>
            </strong>
          </div>
          {isAnalyticalView && (
            <AppCharts
              height={140}
              color="#ffffff"
              data={getChartDataByMetric("total_received")}
              tickColor="#ffffff"
            />
          )}
        </article>
        <article>
          <div className="ads-cards-title">
            <span>Fill rate</span>
            <strong>{analyticData?.fill_rate ?? "0"}%</strong>
          </div>
          {isAnalyticalView && (
            <AppCharts
              height={140}
              color="#ffffff"
              data={getChartDataByMetric("fill_rate")}
              tickColor="#ffffff"
              suffix={'%'}
            />
          )}
        </article>
      </div>
      {tooltip && (
        <AppTooltip
          text={tooltip.text}
          position={{ x: tooltip.x, y: tooltip.y }}
        />
      )}
    </div>
  );
}
